"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Tab_styled_exports = {};
__export(Tab_styled_exports, {
  StyledBadge: () => StyledBadge,
  StyledContentContainer: () => StyledContentContainer,
  StyledTab: () => StyledTab,
  boxShadowStyles: () => boxShadowStyles,
  focusSelectedStyles: () => focusSelectedStyles,
  tabFocusStyles: () => tabFocusStyles,
  tabStyles: () => tabStyles
});
module.exports = __toCommonJS(Tab_styled_exports);
var import_atoms = require("../../../atoms");
var import_styled_components = __toESM(require("styled-components"));
var import_baseTheme = __toESM(require("../../../../themes/baseTheme"));
var tabFocusStyles = (0, import_styled_components.css)(["transition-delay:0.15s;outline:none;border-radius:4px;box-shadow:", " ", " inset,", " ", " inset;"], import_baseTheme.default.colors.beige[180], import_baseTheme.default.measurements.shadows.extraSmall, import_baseTheme.default.colors.white, import_baseTheme.default.measurements.shadows.small);
var boxShadowStyles = (0, import_styled_components.css)(["box-shadow:", " ", " inset,", " ", " inset,0px -5px 0 0 ", " inset;"], import_baseTheme.default.colors.beige[180], import_baseTheme.default.measurements.shadows.extraSmall, import_baseTheme.default.colors.white, import_baseTheme.default.measurements.shadows.small, import_baseTheme.default.colors.pr.base);
var focusSelectedStyles = (0, import_styled_components.css)(["outline:none;border-radius:4px;", ";"], boxShadowStyles);
var StyledBadge = (0, import_styled_components.default)(import_atoms.Badge).withConfig({
  displayName: "Tabstyled__StyledBadge",
  componentId: "sc-1natxkj-0"
})(["padding:0 7px;"]);
var StyledContentContainer = import_styled_components.default.div.withConfig({
  displayName: "Tabstyled__StyledContentContainer",
  componentId: "sc-1natxkj-1"
})(["display:flex;flex-direction:column;align-items:flex-start;text-align:left;word-break:break-all;"]);
var tabStyles = function tabStyles2(_ref) {
  var selected = _ref.selected, isDisabled = _ref.isDisabled, fontSize = _ref.fontSize, isBold = _ref.isBold;
  return (0, import_styled_components.css)(["align-items:center;background-color:transparent;border:none;display:inline-flex;font-family:", ";font-size:", ";font-weight:", ";justify-content:center;line-height:24px;outline:none;text-align:center;color:", ";box-shadow:", ";"], import_baseTheme.default.typography.fonts.primary, import_baseTheme.default.typography.sizes[fontSize], selected && isBold ? import_baseTheme.default.typography.weights.bold : import_baseTheme.default.typography.weights.regular, import_baseTheme.default.colors.n[isDisabled ? 60 : 100], selected && "0px -5px 0 -1px ".concat(import_baseTheme.default.colors.pr.base, " inset"));
};
var StyledTab = import_styled_components.default.button.withConfig({
  displayName: "Tabstyled__StyledTab",
  componentId: "sc-1natxkj-2"
})(function(_ref2) {
  var theme = _ref2.theme, isDisabled = _ref2.isDisabled, selected = _ref2.selected, fontSize = _ref2.fontSize, isBold = _ref2.isBold;
  return (0, import_styled_components.css)(["", " cursor:", ";flex-shrink:0;height:100%;min-height:56px;padding:0 24px;i{margin-right:4px;}@media (hover:hover){&:hover{color:", ";}}&:focus{", ";}&:active{background-color:", ";}"], tabStyles({
    selected,
    isDisabled,
    fontSize,
    isBold
  }), isDisabled ? "not-allowed" : "pointer", isDisabled ? theme.colors.n[60] : theme.colors.pr.base, selected ? focusSelectedStyles : tabFocusStyles, isDisabled ? "transparent" : theme.colors.beige[100]);
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StyledBadge,
  StyledContentContainer,
  StyledTab,
  boxShadowStyles,
  focusSelectedStyles,
  tabFocusStyles,
  tabStyles
});
//# sourceMappingURL=Tab.styled.js.map